import React from 'react';
import Icon from './Icon';

const Search = (props) => {
  const { strokeWidth = 1.5, ...remainingProps } = props;
  return (
    <Icon viewBox="0 0 24 24" {...remainingProps}>
      <title>Search</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g stroke="currentColor" strokeWidth={strokeWidth}>
          <g transform="translate(5.000000, 4.000000)">
            <circle cx="5.79044118" cy="5.625" r="5.625"></circle>
            <path d="M9.85753676,9.85753676 L14.2555147,14.2555147" strokeLinecap="round" strokeLinejoin="round"></path>
          </g>
        </g>
      </g>
    </Icon>
  );
};

export default Search;
